import { Component, OnInit, ViewChild } from '@angular/core';
import { StudentMaster } from '../model/StudentMaster.model';
import { User } from '../model/User.model';
import { AuthService } from '../service/auth.service';
import { EnrollCourseMaster } from '../model/EnrollCourseMaster.model';
import { MainserviceService } from '../service/mainservice.service';
import { SessionClient } from '../configration/sessionclient.storage';
import { Router } from '@angular/router';
import { ReceiptMaster } from '../model/ReceiptMaster.model';
import { StudentLectureMaster } from '../model/StudentLectureMaster.model';
import {ChangeDetectionStrategy,TemplateRef} from '@angular/core';
import { startOfDay, endOfDay,subDays,addDays,endOfMonth,isSameDay, isSameMonth, addHours} from 'date-fns';
import {CalendarEvent,CalendarEventAction,CalendarEventTimesChangedEvent,CalendarView,} from 'angular-calendar';
import { HttpErrorResponse } from '@angular/common/http';
import { CourseMaster } from '../model/CourseMaster.model';
import { LectureMaster } from '../model/LectureMaster.model';
import { PredefinedMaster } from '../model/PredefinedMaster.model';
import { CourseHistory } from '../model/CourseHistory.model';
import { DocumentMaster } from '../model/DocumentMaster.model';
import Player from '@vimeo/player';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import timeGridPlugin from '@fullcalendar/timegrid';
// import interactionPlugin from '@fullcalendar/interaction';

// import {FullCalendar } from 'primeng/fullcalendar';
const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};



@Component({
  selector: 'app-student-dashboard',
  templateUrl: './student-dashboard.component.html',
  styleUrls: ['./student-dashboard.component.scss']
})

export class StudentDashboardComponent implements OnInit {
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();
  modalData: {
    action: string;
    event: CalendarEvent;
  };
  // @ViewChild('fc',{static: false}) fc: FullCalendar;
  enrollCourseMaster:EnrollCourseMaster = new EnrollCourseMaster();
  enrollCourseMasterLectureSwitch:EnrollCourseMaster[] =[];
  studentMaster:StudentMaster = new StudentMaster();
  switchLecture:boolean= false;
  studentLectureMasterList:StudentLectureMaster[]=[];
  studentLectureMaster:StudentLectureMaster= new StudentLectureMaster();
  cities: any[];
  selectedCity: any;
  cars: any[];
  options: any;
  cols: any[];
  festival:any;
  courselistTemp:CourseMaster=new CourseMaster();
  courselistTemp1:CourseMaster=new CourseMaster();
  courseMasterTemp:CourseMaster=new CourseMaster();

  player;
  documentMasterTemp:DocumentMaster=new DocumentMaster();


  showVideo:boolean=false;

  pageSize: number = 3;
  pageNumber: number = 0;
  showbtn:boolean=true;
  showbtn1:boolean=true;
  showbtn2:boolean=true;

  totalRecords:number=0;
  totalRecords1:number=0;
  

  predefinedMaster:PredefinedMaster=new PredefinedMaster();

  ongoingEnrollCourseMasterList:EnrollCourseMaster[]=[];
  completedEnrollCourseMasterList:EnrollCourseMaster[]=[];

  student:StudentMaster=new StudentMaster();

  val: number;
  dashboardStats:StudentMaster[]=[];
  courseHistory:CourseHistory=new CourseHistory();
  courseHistoryList:CourseHistory[]=[];

  activeDayIsOpen: boolean = true;
  displayNotPaidMessage:string;
  courseMaster:CourseMaster = new CourseMaster();
  courseMasterList:CourseMaster[]=[];
  courseMasterList1:CourseMaster[]=[];
  isInvisible:boolean=false;
  liveVoteEventCauroselLimit: number = 4;
  constructor(private authService:AuthService,private mainService:MainserviceService,public sessionClient:SessionClient,public router:Router,private sanitizer: DomSanitizer,public spinnerService: NgxSpinnerService) {
 

  this.festival =  {
    loop: false,
    autoplay:false,
    autoplayTimeout:5000,
    margin:20,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    items:this.liveVoteEventCauroselLimit,
    navSpeed: 1000,
    navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 3
      },
      940: {
        items: 6
      }
    },
    nav: true
  }
  
   }

  ngOnInit() {
    this.spinnerService.show()
    this.student=this.authService.getUserSession();

    this.getDashboardStats()
    this.getEnrollCourse('ONGOING');
    this.getCourseMasterList(this.courselistTemp);
    this.getCourseMasterList(this.courselistTemp1);
    this.getCourseMasterById();
    this.getCourseHistory();
  
  

  
    
 
  }
  getDashboardStats() {

    let studentMaster=new StudentMaster();
    studentMaster.studentMasterId=this.student.studentMasterId

   
    
    this.mainService.getDashboardStats(studentMaster).subscribe(
      (data) => {
        this.dashboardStats = data;
       
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }


  getCourseMasterById(){
   
    // this.courseMasterTemp.courseMasterId= 1;
  
   this.mainService.getMasterCourse(this.courseMasterTemp).subscribe(data => {
     this.courseMaster = data;
     this.spinnerService.hide()

  }, (err: HttpErrorResponse) => {
    if (err.status === 200) {
      let jsonString = err.error.text;
      jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
      // this.packageServiceList = JSON.parse(jsonString);

    }


  })


 }



  getCourseMasterList(course:CourseMaster) {
    this.courselistTemp.isMasterCourse=false;

    this.courselistTemp.pageNumber = this.courselistTemp.pageNumber
      ? this.courselistTemp.pageNumber
      : this.pageNumber;
      this.courselistTemp.pageSize = this.courselistTemp.pageSize
      ? this.courselistTemp.pageSize
      : this.pageSize;
    
    this.mainService.getCourseMasterList(course).subscribe(
      (data) => {
        if(course==this.courselistTemp){
        this.courseMasterList = data;
        this.getCourseMasterListLength();
      }
      else if(course==this.courselistTemp1){
        this.courseMasterList1 = data;
      }
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }

  closeBannerVideo(){
    this.showVideo=false;
  }

  startExam(){
    this.router.navigateByUrl('/exam');
  }


  getCourseHistory() {

    this.courseHistory.user=this.student.user
    this.courseHistory.user.id=this.student.studentMasterId;
   
    
    this.mainService.getCourseHistory(this.courseHistory).subscribe(
      (data) => {
        
        this.courseHistoryList = data;
       
        
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }


  incrementPage(){

    this.courselistTemp.pageNumber=this.courselistTemp.pageNumber
    this.courselistTemp.pageSize=this.courselistTemp.pageSize+3
  
  
    this.getCourseMasterList(this.courselistTemp);
    
    

   if(this.courselistTemp.pageSize>=this.totalRecords){
     
     this.showbtn=false;
   }
    
  }

  getEnrollCourse(code:string){
  

    let courseStatus = new PredefinedMaster();
    courseStatus.code=code

    this.enrollCourseMaster.courseStatus = courseStatus;

    let studentTemp = new StudentMaster();
    studentTemp.studentMasterId = this.authService.getUserSession().studentMasterId;

    this.enrollCourseMaster.studentMaster = studentTemp;


      this.enrollCourseMaster.pageNumber = this.enrollCourseMaster.pageNumber
    ? this.enrollCourseMaster.pageNumber
    : this.pageNumber;
  this.enrollCourseMaster.pageSize = this.enrollCourseMaster.pageSize
    ? this.enrollCourseMaster.pageSize
    : this.pageSize;


    this.mainService.getMyEnrolledCourseList(this.enrollCourseMaster).subscribe(data=>{
      if(code=='ONGOING'){
      this.ongoingEnrollCourseMasterList = data;
      this.getEnrollListLength('ONGOING');
    }else if(code=='COMPLETED'){
      this.completedEnrollCourseMasterList=data;
    }
    })
  
  }


  viewEnrollCourseMaster(enrollCourseMaster:EnrollCourseMaster){
    let enrollCourseMasterTemp = new EnrollCourseMaster();
    enrollCourseMasterTemp.enrollCourseMasterId = enrollCourseMaster.enrollCourseMasterId;
    this.authService.setEnrollCourseMasterSession(enrollCourseMasterTemp);
    this.router.navigateByUrl('/mycourse-details');
  }


  incrementPage2(){

    this.router.navigateByUrl('/my-course')
    console.log(this.enrollCourseMaster.pageSize,"this.enrollCourseMaster.pageSize");
    console.log(this.totalRecords1,"this.totalRecords1");

    if(this.enrollCourseMaster.pageSize>=this.totalRecords1){
     
      this.showbtn2=false;
    }

    
  }

  navigateMaster(){
    this.router.navigateByUrl('/master-course')
  }


 
  updateStudentDetails(){
    let user:User = new User();
    // user=this.authService.getUserSession();

    this.studentMaster.studentMasterId=user.id;
    this.studentMaster.defaultEnrollCourseMasterId = this.enrollCourseMaster.enrollCourseMasterId;

    this.mainService.updateStudentDetail(this.studentMaster).subscribe(data=>{
        this.studentMaster = data;

    },(err: HttpErrorResponse)=>{
      if (err.status === 200) {
        let jsonString=err.error.text;
        jsonString=jsonString.substr(0, jsonString.indexOf('{"timestamp"}'));
        // this.user = JSON.parse(jsonString);
        //json circular break at server side always add
        //extra information of timestamp and status along with
        //main json so parsing occurs still at status 200
      }
    })
  }

  getStudentLecture(receiptMaster:ReceiptMaster){
      let enrollCourseMasterTemp:EnrollCourseMaster = new EnrollCourseMaster();
      enrollCourseMasterTemp.enrollCourseMasterId= this.enrollCourseMaster.enrollCourseMasterId;
      let receiptMasterTemp:ReceiptMaster = new ReceiptMaster();
      receiptMasterTemp.receiptMasterId = receiptMaster.receiptMasterId;
      enrollCourseMasterTemp.receiptMasterTemp = receiptMasterTemp;
      this.viewDate = new Date(receiptMaster.receiptMonthTemp);

      this.mainService.getStudentLectureMasterOnDashboard(enrollCourseMasterTemp).subscribe(data=>{
        this.studentLectureMasterList = data;
      });

  }
  getStudentMasterId(studentLectureMaster:StudentLectureMaster){

    if(studentLectureMaster.studentLectureMasterId != null){
      this.studentLectureMaster.studentLectureMasterId = studentLectureMaster.studentLectureMasterId;
      this.mainService.setstudentLectureMaster(this.studentLectureMaster);
      this.router.navigate(['/student-learning/']);
    }

  }


  // viewEnrollCourseMaster(enrollCourseMaster:EnrollCourseMaster){
  //   let enrollCourseMasterTemp = new EnrollCourseMaster();
  //   enrollCourseMasterTemp.enrollCourseMasterId = enrollCourseMaster.enrollCourseMasterId;
  //   this.authService.setEnrollCourseMasterSession(enrollCourseMasterTemp);
  //   this.router.navigateByUrl('/mycourse-details');
  // }


  viewCourse(courseMaster:CourseMaster){
    this.authService.setcourseMasterSession(courseMaster);
   
    
      this.router.navigateByUrl('/course-details');
    
  }


  getCourseMasterListLength() {
   

    this.courselistTemp.isMasterCourse=false;



    this.mainService.getCourseMasterListLength(this.courselistTemp).subscribe(data => {
      this.totalRecords = data;

    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
        this.courseMasterTemp = JSON.parse(jsonString);

      }


    })
  }


  getEnrollListLength(code:string) {
   
    this.mainService.getEnrollCourseMasterListLength(this.enrollCourseMaster).subscribe(data => {

      if(code=='ONGOING'){
        this.totalRecords1 = data;
      }
      
    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
        this.enrollCourseMaster = JSON.parse(jsonString);

      }


    })
  }

  videoDisplay(){

    this.documentMasterTemp = this.courseMaster.courseBannerVideo;
    if (this.documentMasterTemp.linkId != null && this.documentMasterTemp.linkId != undefined) {
      this.documentMasterTemp.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentMasterTemp.link);
    }

    this.showVideo=!this.showVideo;

    setTimeout(() => {
      this.initPlayer();
      this.setVideo(this.documentMasterTemp.linkId);
    
      this.playVideo();
     
    }, 500);


  }

  public initPlayer() {
    this.player = new Player('video_iframe', {});
    // this.updateVideoCompleted();
  }
  
  setVideo(videoId: any) {
  
    // this.destroyPlayer();
    // this.initPlayer();
    
    this.player.loadVideo(videoId).then(function (id) {
  
    });
  
  }
  
  playVideo() {
    setTimeout(() => {
      this.player.play().then(function () {
  
      });
    }, 1000);
  
  }
  
 

}
